import {ProfileCustomerLifecycleCards} from "~/components/entityProfile/lifecycle/profileCustomerLifecycleCards";
import {ProfileLifecycleTabFilters} from "~/components/entityProfile/lifecycle/profileLifecycleTabFilters";
import type {CustomerProfileLifecycleContext} from "~/components/entityProfile/lifecycle/types";

export function ProfileLifecycleTabView({lifecycle}: {lifecycle: CustomerProfileLifecycleContext}) {
    return (
        <div className="h-full min-h-0 overflow-y-auto overscroll-contain px-ds-space-200 py-ds-space-150">
            <div className="grid gap-y-ds-space-200">
                <ProfileLifecycleTabFilters />
                <ProfileCustomerLifecycleCards
                    lifecycles={lifecycle.lifecycles}
                    highlightActiveSelection={true}
                />
            </div>
        </div>
    );
}
